import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAngleUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#8cd7fa",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 10
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "#0050a0",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "m13.8251 11.5-3.6364-3.63637" }), /* @__PURE__ */ _jsx("path", { d: "m10.1891 7.86363-3.63637 3.63637" })]
	})]
});
export default SvgAngleUp;
